import {useMemo} from 'react';
import type {Thesaurus, ThesaurusValue} from '../types';
import {getTrimmedThesaurus} from '../functions';

/**
 * Remove all deactivated nodes, unless currently selected (i.e. part of value)
 */
export const useTrimmedThesaurus = (
  fullThesaurus: Thesaurus,
  initialValue: ThesaurusValue | undefined,
  skipTrimming: boolean,
): Thesaurus => {
  return useMemo(
    () =>
      skipTrimming
        ? fullThesaurus
        : getTrimmedThesaurus(fullThesaurus, initialValue),
    [fullThesaurus, initialValue, skipTrimming],
  );
};
